module.exports = __webpack_public_path__ + "img/co-branding-logo-dunkin.610e3c91.png";